module.exports = __webpack_public_path__ + "static/media/academia_01.7877b4ff.jpg";